"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONLINE_OFFLINE_MODE_ALL = exports.ONLINE_OFFLINE_MODE_OFFLINE = exports.ONLINE_OFFLINE_MODE_ONLINE = void 0;
exports.ONLINE_OFFLINE_MODE_ONLINE = "online";
exports.ONLINE_OFFLINE_MODE_OFFLINE = "offline";
exports.ONLINE_OFFLINE_MODE_ALL = "all";
//# sourceMappingURL=OnlineOfflineMode.js.map